import { Component, Input, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import _ from "lodash";
import * as moment from "moment";

import { CleanLevelList, TaskTypeList } from "@root/router/task-v2/task-v2.props";
import { DateService } from "@root/shared/service/date.service";
import { StoreService } from "@root/shared/service/store.service";
import { CreateTaskService } from "@root/router/component/task/create-task/create-task.service";
import { NzModalRef } from "ng-zorro-antd/modal";
import { Router } from "@angular/router";
import { filter, tap } from "rxjs";
import { zip } from "rxjs";
import { InternationalService } from "@root/international.service";

/** @deprecated 逻辑混乱，代码质量太次，废弃 */
@Component({
  selector: "host-create-task",
  templateUrl: "./create-task.component.html",
  styleUrls: ["./create-task.component.scss"],
})
export class CreateTaskComponent implements OnInit {
  @Input() data = null;
  form: UntypedFormGroup = this.fb.group({
    type: 0,
    house_id: [null, Validators.required],
    schedule_staff_id: null,
    expected_date: null,
    expected_time: null,
    level: 0, // 默认为标准，仅保洁任务有保洁等级,
    fee: 0,
    currency_type: this.intlSrv.getCurrency(),
    gen_transaction: false,
    payment_method: null,
    note: null,
    photos: [[]],
    check_list: [[]],
  });
  typeList = _.filter(TaskTypeList, function (type) {
    return type.value >= 0;
  });
  cleanLevelList = _.filter(CleanLevelList, function (level) {
    return level.value >= 0;
  });
  fees = {
    standard: 0,
    simple: 0,
    advance: 0,
    currency: "CNY",
  };
  currencyList = [];
  listOfMethodOption = [];

  // checking = false;

  btnLoading = false;

  get angularDateFormat() {
    return this.dateService.getAngularFormat(["YMD"]);
  }

  get angularTimeFormat() {
    return this.dateService.getAngularFormat([null, "hm"]);
  }

  get use12Hours() {
    return this.dateService.use12hr;
    // const timeFormat = this.dateService.getTimeFormat();
    // return timeFormat === IntlTimeFormat.Twelve ? true : false;
  }

  get isEditMode() {
    return !!this.data?.id;
  }

  get isCleaningType() {
    return this.form.get("type").value === 0;
  }

  get checkList() {
    return this.form.get("check_list").value;
  }

  constructor(
    private fb: UntypedFormBuilder,
    private intlSrv: InternationalService,
    private dateService: DateService,
    private localService: StoreService,
    private createTaskService: CreateTaskService,
    private subject: NzModalRef,
    private router: Router,
  ) {}

  ngOnInit() {
    this.initOptionList();
  }

  private initOptionList() {
    // this.getTypes();
    // this.getAssignees();
    zip(this.fetchCurrencyOptions(), this.fetchPaymentMethodOptions()).subscribe(() => {
      this.initFormData();
    });
  }

  private fetchCurrencyOptions() {
    return this.createTaskService.getCleaningFeeCurrencyList({ for_filter: 0 }).pipe(
      filter((rst) => rst.error_code === 0),
      tap((rst) => (this.currencyList = rst?.data?.list)),
    );
  }

  private fetchPaymentMethodOptions() {
    return this.createTaskService.getSettings().pipe(
      filter((rst) => rst.error_code === 0),
      tap((rst) => (this.listOfMethodOption = rst?.data?.income_method?.filter((m) => m.delete_time === null))),
    );
  }

  private initFormData() {
    console.log("this.data: ", this.data);
    if (this.data) {
      const expected_date = this.data.expected_date ? moment(this.data.expected_date).toDate() : null;
      const expected_time = this.data.expected_time
        ? moment(`${this.data.expected_date} ${this.data.expected_time}`).toDate()
        : null;

      const schedule_staff_id =
        (this.data.staff?.id ? [this.data.staff.id] : null) ||
        (this.data.schedule_staff_id ? [this.data.schedule_staff_id] : null);

      this.form.patchValue({
        ...this.data,

        expected_date,
        expected_time,
        schedule_staff_id,
        currency_type: this.data.currency_type || this.currencyList?.[0],
        photos: this.data.photos?.map((photo) => ({ urls: photo })),
      });

      console.log("this.form.value: ", this.form.value);
      if (this.data.house_id) {
        this.onHouseChange(+this.data.house_id);
      }
    } else {
      // const expected_time = moment().startOf('day').add(12, 'hours').toDate();
      const oldSettings = this.localService.get("host_arrange_clean_params", 2) || { diff: 0 };
      this.form.patchValue({
        expected_date: moment().add(oldSettings.diff, "days").toDate(),
        // expected_time: expected_time,
      });
    }
  }

  onHouseChange(houseId) {
    console.log("on hosue chnge: ", houseId);
    console.log("form.value: ", JSON.parse(JSON.stringify(this.form.value)));
    // this.checkedHouses = _.map(house, "id");
    // this.hasCheckedHouses = _.cloneDeep(this.checkedHouses);
    if (houseId) {
      this.getCleanFeeForHouse(houseId);
    }
  }

  //#region Check list

  onAddCheckList() {
    this.checkList.push({ title: "", status: 0 });
  }

  onRemoveCheckList(index) {
    this.checkList.splice(index, 1);
  }

  //#endregion

  getCleanFeeForHouse(houseId) {
    this.createTaskService
      .getCleanFee({
        // house_ids: JSON.stringify([this.form.value.house_id]),
        house_ids: JSON.stringify([houseId]),
      })
      .subscribe((res) => {
        if (res.error_code === 0) {
          const cleaningInfo = _.get(res, "data.list[0].house_cleaning");
          const fee = cleaningInfo.fee;
          this.fees = {
            standard: fee.standard ? fee.standard : 0,
            simple: fee.simple ? fee.simple : 0,
            advance: fee.advance ? fee.advance : 0,
            currency: cleaningInfo.currency_type || this.currencyList[0],
          };
          const staffForHouse = _.get(res, "data.list[0].schedule_staffs[0].id");
          const value = this.form.value;

          if (this.isEditMode) {
            if (!this.data.currency_type) {
              this.form.patchValue({
                currency_type: this.fees.currency,
              });
            }
            if (!this.data.schedule_staff_id && !_.get(this.data, "staff")) {
              this.form.patchValue({
                schedule_staff_id: [staffForHouse],
              });
            }
            if (!value.type && !this.data.fee) {
              this.form.patchValue({
                fee: value.level === 0 ? this.fees.standard : value.level === 1 ? this.fees.simple : this.fees.advance,
              });
            }
          } else {
            const fee = value.type
              ? 0
              : value.level === 0
                ? this.fees.standard
                : value.level === 1
                  ? this.fees.simple
                  : this.fees.advance;
            const currency_type = value.type ? this.currencyList[0] : this.fees.currency;
            this.form.patchValue({
              fee,
              currency_type,
              schedule_staff_id: [staffForHouse],
            });
          }

          console.log("this.form.value: ", this.form.value);
        }
      });
  }

  typeChange() {
    const value = this.form.value;
    if (value.type !== 0) {
      this.form.patchValue({
        fee: 0,
      });
    } else {
      this.form.patchValue({
        fee: value.level === 0 ? this.fees.standard : value.level === 1 ? this.fees.simple : this.fees.advance,
        currency_type: this.fees.currency,
      });
    }
  }

  cleanLevelChange() {
    const value = this.form.value;
    this.form.patchValue({
      fee: value.level === 0 ? this.fees.standard : value.level === 1 ? this.fees.simple : this.fees.advance,
    });
  }

  toTasksFee() {
    this.router.navigate(["/app/tasks/default-cleaning-fee"]);
    this.subject.close();
  }

  save() {
    // this.checking = true;
    this.form.markAllAsTouched();

    if (this.hasRequiredError("house_id")) {
      return;
    }

    if (this.isEditMode) {
      this.requestUpdateTask();
    } else {
      this.requestCreateTask();
    }
  }

  private requestUpdateTask() {
    this.btnLoading = true;
    const value = this.form.value;

    const photos = value.photos?.map((file) => file.urls);

    const params = {
      ...value,
      id: this.data.id,
      expected_date: moment(value.expected_date).format("YYYY-MM-DD"),
      expected_time: value.expected_time ? moment(value.expected_time).format("HH:mm:ss") : null,
      photos: photos ? JSON.stringify(photos) : null,
      schedule_staff_id: value.schedule_staff_id?.[0],
      // gen_transaction: value.gen_transaction ? 1 : null,
    };

    this.createTaskService.updateTask(params).subscribe((res) => {
      this.btnLoading = false;
      if (res.error_code === 0) {
        this.subject.destroy("OK");
      }
    });
  }

  private requestCreateTask() {
    this.btnLoading = true;
    const value = this.form.value;
    console.log("form value: ", value);

    const diff = moment(value.expected_date).diff(moment().startOf("day"), "days");
    this.localService.set(
      "host_arrange_clean_params",
      {
        diff: diff,
      },
      2,
    );

    const photos = value.photos?.map((file) => file.urls);

    const params = {
      ...value,
      expected_date: moment(value.expected_date).format("YYYY-MM-DD"),
      expected_time: value.expected_time ? moment(value.expected_time).format("HH:mm:ss") : null,
      photos: photos ? JSON.stringify(photos) : null,
      schedule_staff_id: value.schedule_staff_id?.[0],
      gen_transaction: value.gen_transaction ? 1 : null,
    };
    console.log("params: ", params);
    this.createTaskService.createTask(params).subscribe((res) => {
      this.btnLoading = false;
      if (res.error_code === 0) {
        this.subject.destroy("OK");
      }
    });
  }

  hasRequiredError(fieldName: string): boolean {
    const control = this.form.get(fieldName);
    return control?.hasError("required") && control?.touched;
  }

  cancel() {
    this.subject.destroy();
  }

  checkValid() {
    const value = this.form.value;
    if (this.invalid(value.type) || this.invalid(value.expected_date) || this.invalid(value.fee)) {
      return false;
    }
    return true;
  }

  invalid(data) {
    if (Array.isArray(data)) {
      return data.length === 0 ? true : false;
    }
    return data === null ? true : data === "" ? true : false;
  }
}
